<template>
  <Select :source="`vendor-account/search`" placeholder="Vendor Account" :value="value" @changeValue="store.commit(`${this.storeId}.value`, $event)" :multiple="multiple"></Select>
</template>

<script>
import DefaultValue from './DefaultValue.vue'
export default {
  extends: DefaultValue,
  computed: {
    multiple() {
      return this.condition.condition == 'contain'
    },
    value() {
      if (!this.multiple) {
        if (this.$util.isObjectId(this.condition.value)) {
          return this.condition.value
        }
      } else if (_.isArray(this.condition.value)) {
        return this.condition.value.filter((item) => this.$util.isObjectId(item))
      }
      return null
    }
  },
  methods: {
    //
  }
}
</script>
